// this file is automatically generated by git.version.ts script
export const versions = {commit: '7338ba729', tag: '2026.5.001-RELEASE'};
